import {Suspense} from "react";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import {modulesPreloads, modulesRoutes} from "../modules";
import AppContext from "./AppContext";
import LoadRouteWrappers from "./LoadRouteWrappers";


function Router({context}) {

    const layoutWrappers = (route, lang, index=0) => {
        if(!route.layouts[index])       {
            return <Route key={index} index path={route.fullpath[lang]} element={
                <Suspense fallback={<div />}>
                    {route.element}
                </Suspense>
            } />
        }
        if(index === 0) {
            return <Route key={index} path="" element={
                <AppContext.Provider value={{currentRoute: route, ...context}}>
                    <LoadRouteWrappers>
                        {route.layouts[index].element}
                    </LoadRouteWrappers>
                </AppContext.Provider>
            }>
                {layoutWrappers(route, lang, index+1)}
            </Route>
        }
        return <Route key={index} path="" element={
            <Suspense fallback={<div />}>
                {route.layouts[index].element}
            </Suspense>
        }>
            {layoutWrappers(route, lang, index+1)}
        </Route>
    }

    return <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<div />}>
            <Routes>
                {Object.values(modulesRoutes).map((route, index) => {
                    return route.path.map((path, lang) => {
                        return layoutWrappers(route, lang);
                    })
                })}
            </Routes>
        </Suspense>
    </BrowserRouter>
}
export default Router;
